import React, {useMemo} from 'react';

import ContentfulImage from 'brand/app/contentful/classes/ContentfulImage';
import {useIsFirstModuleImage} from 'brand/app/contentful/components/Page/FirstModuleContext';
import {useHeaderCtx} from 'brandComponents/Header/HeaderCtx';
import Picture from 'brandComponents/Picture';

import {IImageContentfulProps} from './IImageContentful';

const ImageContentful = (props: IImageContentfulProps) => {
	const image = new ContentfulImage(
		props.internalTitle,
		{
			xs: props.image?.props || null,
			sm: props.imageSm?.props || null,
			md: props.imageMd?.props || null,
			lg: props.imageLg?.props || null,
			xl: props.imageXl?.props || null,
		},
		!!props?.lossless
	);

	const isFirstModuleImage = useIsFirstModuleImage();
	// The menu images of the header are never the LCP.
	const isInHeader = !!useHeaderCtx(true)?.isInHeaderContext;

	const threshold = useMemo(() => {
		return typeof props.threshold === 'number'
			? props.threshold
			: 0.2;
	}, []);

	return (
		<div className="image-wrapper">
			<Picture
				{...props}
				image={image}
				showPlaceholder={props.showPlaceholder}
				priority={isFirstModuleImage && !isInHeader}
				threshold={threshold}
				printTitle={false}
			/>
		</div>
	);
};

export default ImageContentful;
